<tt-page *ngIf="!!page" class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-select ttRememberId="w_choicepossrules.choice_prod_id" ttLabel="choice_prod_name" [(ttModel)]="page.choice_prod_id" (ttModelChange)="onChoiceProductChanged($event)" [ttData]="selectListProductChoices" ttDataId="prod_id" ttDataName="prod_name"></tt-select>
        <tt-select
            ttRememberId="w_choicepossrules.model_id"
            ttLabel="model_name"
            [(ttModel)]="page.model_id"
            (ttModelChange)="onModelChanged($event)"
            [ttData]="selectListModels"
            ttDataId="model_id"
            ttDataName="model_name"
            [ttShowClearButton]="page.model_id !== 'ALL'"
            ttClearValue="ALL"
        >
            <ng-container buttons>
                <tt-form-field-button ttIcon="fas fa-bars" ttType="primary" ttGoto="models"></tt-form-field-button>
                <tt-form-field-button *ngIf="page.model_id !== 'ALL'" ttIcon="fas fa-chevron-right" ttType="primary" ttGoto="modelmenu" [ttGotoParms]="{ model_id: page.model_id }"></tt-form-field-button>
            </ng-container>
        </tt-select>
        <tt-input ttLabel="prod_id" [ttModel]="page.prod_id" ttReadonly>
            <ng-container buttons>
                <tt-form-field-button *ngIf="page.prod_id > ''" ttIcon="fas fa-chevron-right" ttType="primary" (ttClick)="goToProduct(page.prod_id)"></tt-form-field-button>
            </ng-container>
        </tt-input>
        <tt-select *ngIf="page.nbr_of_products < 200" ttRememberId="w_choicepossrules.prod_id" ttLabel="prod_name" [(ttModel)]="page.prod_id" (ttModelChange)="onProductNameChanged($event)" [ttData]="selectListProductNames" ttDataId="prod_id" ttDataName="prod_name" ttShowClearButton ttClearValue=""></tt-select>
        <tt-search *ngIf="page.nbr_of_products >= 200" ttRememberId="w_choicepossrules.prod_id" ttLabel="prod_name" [(ttModel)]="page.prod_name" [ttSearch]="searchProducts" (ttOnSelected)="onProductSearchSelected($event)" (ttOnClear)="onProductSearchCleared()"></tt-search>
        <ng-container *ngIf="page.nbr_of_furniturefabrics > 0">
            <tt-select
                ttRememberId="w_choicepossrules.furniturefabrics_id"
                ttLabel="furniturefabrics_name"
                [(ttModel)]="page.furniturefabrics_id"
                (ttModelChange)="onFurnitureFabricsChanged($event)"
                [ttData]="selectListFurnitureFabrics"
                ttDataId="furniturefabrics_id"
                ttDataName="furniturefabrics_name"
                [ttShowClearButton]="page.furniturefabrics_id !== 'ALL'"
                ttClearValue="ALL"
            >
                <ng-container buttons>
                    <tt-form-field-button ttIcon="fas fa-bars" ttType="primary" ttGoto="furniturefabricss"></tt-form-field-button>
                    <tt-form-field-button *ngIf="page.furniturefabrics_id !== 'ALL'" ttIcon="fas fa-chevron-right" ttType="primary" ttGoto="furniturefabrics" [ttGotoParms]="{ furniturefabrics_id: page.furniturefabrics_id }"></tt-form-field-button>
                </ng-container>
            </tt-select>
        </ng-container>
        <tt-select
            *ngIf="selectListChosenProducts.length > 0"
            ttRememberId="w_choicepossrules.prod_id_choosed"
            ttLabel="prod_id_choosed"
            [(ttModel)]="page.prod_id_choosed"
            (ttModelChange)="onChosenProductChanged($event)"
            [ttData]="selectListChosenProducts"
            ttDataId="prod_id_choosed"
            ttDataName="prod_name_choosed"
            [ttShowClearButton]="page.prod_id_choosed > ''"
            ttClearValue=""
        >
            <ng-container buttons>
                <tt-form-field-button *ngIf="page.prod_id_choosed > ''" ttIcon="fas fa-chevron-right" ttType="primary" (ttClick)="goToProduct(page.prod_id_choosed)"></tt-form-field-button>
            </ng-container>
        </tt-select>
        <tt-button ttText="choicepossrules_retrieve" (ttClick)="refresh()" [ttLoading]="refreshing" ttTextAlign="center" ttType="primary" ttIcon="fas fa-sync-alt"></tt-button>
        <tt-button-goto ttText="choicepossrules_new" ttGoto="choicepossrule" [ttGotoParms]="{ choicepossrule_keyno: '0' }" ttTextAlign="left" ttIcon="fas fa-plus" ttIconPullRight></tt-button-goto>
        <tt-button-goto ttText="choicepossrules_run" ttGoto="choicepossrulesrun" ttTextAlign="left"></tt-button-goto>
    </tt-card>
    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListRules"></tt-list>
</tt-page>
